import { render, staticRenderFns } from "./manager-search-book-ratio.vue?vue&type=template&id=980388be&"
import script from "./manager-search-book-ratio.vue?vue&type=script&lang=js&"
export * from "./manager-search-book-ratio.vue?vue&type=script&lang=js&"
import style0 from "./manager-search-book-ratio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports